import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import submit from './submit';
import validate from './validate';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';

import InputFieldComponent from '../Common/FormField/InputFieldComponent';
import SelectFieldComponent from '../Common/FormField/SelectFieldComponent';
import CustomCheckbox from '../CustomCheckbox/CustomCheckbox';

import messages from '../../locale/messages';
import PopulateData from '../../helpers/populateData';

import s from './RegisterForm.css';
import bt from '../../components/commonStyle.css';

const RegisterForm = ({ error, handleSubmit, submitting }) => {

  const [dateOfBirthData, setDateOfBirthData] = useState({});
  const [showPassword, setShowPassword] = useState('');

  const { formatMessage } = useIntl();

  useEffect(() => {
    const initDateData = () => {
      const now = new Date();
      const currentYear = now.getFullYear();
      const years = PopulateData.generateData(1920, currentYear, "desc");
      const days = PopulateData.generateData(1, 31);
      const months = PopulateData.generateData(0, 11);
      setDateOfBirthData({ years, months, days });
    };
    initDateData();
  }, []);

  const handleChange = (fieldName) => {
    setShowPassword(fieldName == showPassword ? "" : fieldName);
  }

  const checkboxGroup = ({ input, meta: { touched, error }, children, className, selectClass, name }) => {
    return (
      <div className={cx(s.registerCheckBoxContainer)}>
        <CustomCheckbox
          name={name}
          className='commonCustomCheckBox'
          containerClassName={cx(s.registerCheckBox)}
          checked={input.value == true}
          onChange={event => {
            return input.onChange(event);
          }}
        />
        <div className={cx(s.registerCheckBoxLabel)}>
          <FormattedMessage {...messages.terms1} />&nbsp;
          <a href={"/terms-of-service"} target={'_blank'} className={cx(s.registerCheckBoxLabelLink)}><FormattedMessage {...messages.termsOfService} /></a>&nbsp;
          <FormattedMessage {...messages.and} />&nbsp;
          <a href={"/privacy"} target={'_blank'} className={cx(s.registerCheckBoxLabelLink)}><FormattedMessage {...messages.privacyPolicy} /></a>
        </div>
      </div>
    )
  }

  const generateSelectOptions = (labelMsg, items, formatter) => [
    { value: '', label: formatMessage(labelMsg) },
    ...(items?.map(item => ({
      value: item,
      label: formatter ? formatter(item) : item
    })) || [])
  ];

  const monthValue = generateSelectOptions(messages.month, dateOfBirthData.months, item => item + 1);
  const daysValue = generateSelectOptions(messages.transferDate, dateOfBirthData.days);
  const yearsValue = generateSelectOptions(messages.year, dateOfBirthData.years);

  return (
    <form onSubmit={handleSubmit(submit)} className={cx('SelectFocus', 'inputDateHide')}>
      {error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
      <Field
        name="firstName"
        type="text"
        component={InputFieldComponent}
        label={formatMessage(messages.firstName)}
        placeholder={formatMessage(messages.firstName)}
        inputClass={bt.commonControlInput}
      />
      <Field name="lastName"
        type="text"
        component={InputFieldComponent}
        label={formatMessage(messages.lastName)}
        placeholder={formatMessage(messages.lastName)}
        inputClass={bt.commonControlInput}
      />
      <Field name="email"
        type="text"
        component={InputFieldComponent}
        label={formatMessage(messages.email)}
        placeholder={formatMessage(messages.email)}
        inputClass={bt.commonControlInput}
      />
      <Field
        name="password"
        type="password"
        component={InputFieldComponent}
        label={formatMessage(messages.password)}
        placeholder={formatMessage(messages.password)}
        inputClass={cx("commonPasswordControlInput")}
        showPassword={showPassword}
        isPassword={true}
        onClick={() => handleChange('password')}
      />
      <div className={cx(s.Birthpadding, bt.space3)}>
        <label className={s.loginLabel}>{formatMessage(messages.birthDay)}</label>
        <div className={s.birthFlex}>
          <Field
            name="month"
            component={SelectFieldComponent}
            inputClass={cx(bt.commonControlSelect, "commonControlSelectRtl")}
            options={monthValue}
          />
          <Field
            name="day"
            component={SelectFieldComponent}
            inputClass={cx(bt.commonControlSelect, "commonControlSelectRtl")}
            options={daysValue}
          />
          <Field name="year"
            component={SelectFieldComponent}
            inputClass={cx(bt.commonControlSelect, "commonControlSelectRtl")}
            options={yearsValue}
          />
        </div>
      </div>
      <Field name="termsPolicy" component={checkboxGroup} />
      <Button
        className={cx(bt.btnPrimary, bt.btnBig, bt.space4)}
        block type="submit"
        disabled={submitting}
      >
        {formatMessage(messages.signUp)}
      </Button>
    </form >
  )
}

RegisterForm.propTypes = {
  formatMessage: PropTypes.func,
};

export default reduxForm({
  form: 'RegisterForm', // a unique name for this form
  validate
})(withStyles(s, bt)(RegisterForm));